export default "I er blevet kidnappet. I vågner op i en kælder, lænket til hinanden og til væggen. Kan I undslippe, før jeres kidnapper vender tilbage?";